import { useSelector } from 'react-redux'
import { useQuery } from '@tanstack/react-query'

import { getPatientEmotionalHealthEvaluation } from 'services/patients/getPatientEmotionalHealthEvaluation'

interface IAuthState {
  auth: {
    userData: {
      session: {
        sub: string
      }
    }
  }
}

interface usePatientEmotionalHealthEvaluationType {
  formId: string
  uuid: string
  showNotification: boolean
  isLoading: boolean
  error: number | unknown
}

export function usePatientEmotionalHealthEvaluation(): usePatientEmotionalHealthEvaluationType {

  const { session: { sub }} = useSelector((state: IAuthState) => state.auth.userData)

  const { isLoading, error, data } = useQuery({
    queryKey: ['PatientEmotionalHealthEvaluation', sub],
    queryFn: () => getPatientEmotionalHealthEvaluation({ patientUuid: sub }),
    refetchOnMount: 'always',
    enabled: true
  })

  return {
    formId: data?.formId,
    uuid: data?.uuid,
    showNotification: !!data?.formId,
    error,
    isLoading,
  }
}